import { useQuery } from "@tanstack/react-query";
import { getCallViewsDashboard } from "../services/callViewsApi";
import {
  CallViewsQueryParams,
  CallViewsDashboardData,
} from "../types/call-views.types";

const CALL_VIEWS_QUERY_KEY = "callViewsDashboard";
const STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes
const GC_TIME_MS = 30 * 60 * 1000; // 30 minutes

interface UseCallViewsDashboardOptions {
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
}

export const useCallViewsDashboard = (
  options: UseCallViewsDashboardOptions = {}
) => {
  const { startDate, endDate, enabled = true } = options;

  const queryParams: CallViewsQueryParams = {};
  if (startDate) queryParams.startDate = startDate;
  if (endDate) queryParams.endDate = endDate;

  return useQuery<CallViewsDashboardData, Error>({
    queryKey: [CALL_VIEWS_QUERY_KEY, startDate, endDate],
    queryFn: async () => {
      const response = await getCallViewsDashboard(queryParams);
      return response.data;
    },
    enabled,
    staleTime: STALE_TIME_MS,
    gcTime: GC_TIME_MS,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
  });
};

export default useCallViewsDashboard;
